import React from "react";
import "./App.css";
import { TwitterShareButton } from "react-twitter-embed";
import ReactGA from "react-ga";

ReactGA.initialize("UA-168353586-1");
ReactGA.pageview("/main");

function App() {
  const shareText = `How to help: An actionable list to help support racial justice.\n\n`;

  return (
    <div className="App">
      <h1>How to help</h1>

      <div>
        <h3>A to-do list to help support racial justice.</h3>
      </div>

      <br />
      <TwitterShareButton
        url={"https://how-to-help.netlify.app/"}
        options={{ text: shareText }}
      />

      <h2>Donate</h2>
      <div>
        <ol>
          <li>
            <a
              href="https://www.gofundme.com/f/georgefloyd"
              target="_blank"
              rel="noopener noreferrer"
            >
              George Floyd Memorial Fund
            </a>
          </li>
          <li>
            <a
              href="https://www.gofundme.com/f/gianna-floyd-daughter-of-george-floyd-fund"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gianna Floyd Fund (George Floyd's child)
            </a>
          </li>
          <li>
            <a
              href="https://secure.actblue.com/donate/ms_blm_homepage_2019"
              target="_blank"
              rel="noopener noreferrer"
            >
              Black Lives Matter
            </a>
          </li>
          <li>
            <a
              href="https://minnesotafreedomfund.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Minnesota Freedom Fund
            </a>
          </li>
          <li>
            <a
              href="https://www.blackvisionsmn.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Black Visions Collective
            </a>
          </li>
          <li>
            <a
              href="https://secure.everyaction.com/zae4prEeKESHBy0MKXTIcQ2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Reclaim The Block
            </a>
          </li>
          <li>
            <a
              href="https://secure.actblue.com/donate/freeblackmamas2020"
              target="_blank"
              rel="noopener noreferrer"
            >
              National Bail Out
            </a>
          </li>
          <li>
            <a
              href="https://bailproject.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bail Project
            </a>
          </li>
          <li>
            <a
              href="https://www.joincampaignzero.org/solutions#solutionsoverview"
              target="_blank"
              rel="noopener noreferrer"
            >
              Campaign Zero
            </a>
          </li>
          <li>
            <a
              href="https://www.communityjusticeexchange.org/nbfn-directory"
              target="_blank"
              rel="noopener noreferrer"
            >
              National Bail Fund Network
            </a>
          </li>
          <li>
            <a
              href="https://support.eji.org/give/153413/#!/donation/checkout"
              target="_blank"
              rel="noopener noreferrer"
            >
              Equal Justice Initiative
            </a>
          </li>
        </ol>
      </div>

      <h2>Follow</h2>
      <div>
        <ol>
          <li>
            <a
              href="https://www.instagram.com/blklivesmatter/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @blklivesmatter
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/colorofchange/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @colorofchange
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/naacp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @naacp
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/showingupforracialjustice/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @showingupforracialjustice
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/civilrightsorg/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @civilrightsorg
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/reclaimtheblock/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @reclaimtheblock
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/ethelsclub/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @ethelsclub
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/unitedwedream/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @unitedwedream
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/rachel.cargle/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @rachel.cargle
            </a>
          </li>
        </ol>
      </div>

      <h2>Sign</h2>
      <div>
        <ol>
          <li>
            <a
              href="https://www.change.org/p/mayor-jacob-frey-justice-for-george-floyd"
              target="_blank"
              rel="noopener noreferrer"
            >
              Justice For George Floyd.
            </a>
          </li>
          <li>
            <a
              href="https://act.colorofchange.org/sign/justiceforfloyd_george_floyd_minneapolis"
              target="_blank"
              rel="noopener noreferrer"
            >
              Color of Change
            </a>
          </li>
          <li>
            <a
              href="https://petitions.whitehouse.gov/petition/justice-george-floyd-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              White House Petition.
            </a>
          </li>
          <li>
            <a
              href="https://www.change.org/p/andy-beshear-justice-for-breonna-taylor"
              target="_blank"
              rel="noopener noreferrer"
            >
              Justice For Breonna Taylor.
            </a>
          </li>
          <li>
            <a
              href="https://www.change.org/p/district-attorney-tom-durden-justice-for-ahmaud-arbery-i-run-with-maud"
              target="_blank"
              rel="noopener noreferrer"
            >
              Justice for Ahmaud Arbery.
            </a>
          </li>
        </ol>
      </div>

      <h2>Call</h2>
      <div>
        <ol>
          <li>
            <a
              href="tel:1-612-348-5550"
              target="_blank"
              rel="noopener noreferrer"
            >
              Call DA Mike Freeman
            </a>
            <br />
            demand prosecution to Derek Chauvin (Badge #1087)
            <br />
            and Tou Thoa (badge #7162)
          </li>
          <li>
            <a
              href="tel:1-502-574-2003"
              target="_blank"
              rel="noopener noreferrer"
            >
              Leave a message for Louisville Mayor
            </a>
            <br />
            and demand justice for Breonna Taylor
          </li>
        </ol>
      </div>

      <h2>Text</h2>
      <div>
        <ol>
          <li>
            <a
              href="sms:+155-156&body=FLOYD"
              target="_blank"
              rel="noopener noreferrer"
            >
              Text FLOYD to 55-156
            </a>
          </li>
          <li>
            <a
              href="sms:+1668366&body=JUSTICE"
              target="_blank"
              rel="noopener noreferrer"
            >
              Text JUSTICE to 668366
            </a>
          </li>
          <li>
            <a
              href="sms:+155165&body=ENOUGH"
              target="_blank"
              rel="noopener noreferrer"
            >
              Text ENOUGH to 55165
            </a>
          </li>
        </ol>
      </div>

      <h2>Email</h2>
      <div>
        <ol>
          <li>
            <a
              href="http://tinyurl.com/emailforfloyd"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pre-written email to Minneapolis Police
            </a>
            <br />
            Just type in your name and city
            <br />
            (takes less than 30s)
          </li>
        </ol>
      </div>

      <div class="signature">
        <p>
          (More suggestions?{" "}
          <a
            href="https://twitter.com/richardreeze"
            target="_blank"
            rel="noopener noreferrer"
          >
            Let me know
          </a>
          )
        </p>
      </div>

      <p class="inspired">
        <br />
        Inspired by{" "}
        <a
          href="https://bucketlisters.com/blog/265-how-to-help-fight-for-racial-justice-and-equality-right-now"
          target="_blank"
          rel="noopener noreferrer"
        >
          this post
        </a>
        .
      </p>
    </div>
  );
}

export default App;
